<template>
    <div>
        <LabelList :type="type"></LabelList>
    </div>
</template>

<script>
    import LabelList from './components/labelList';

    export default {
        name: "Category",
        components: {
            LabelList
        },
        data() {
            return {
                type:"CATEGORY_LABEL"
            };
        }
    }
</script>

<style lang="less" scoped>

</style>